<template>
  <DataTable
    ref="DataTable"
    :data-model="'Reservations'"
    :items="reservations"
    :loading="loading"
    @reloadData="reload()"
    :allow-delete="false"
    :allow-create="false"
    :allow-edit="false"
    :allow-view="false"
    :exclude-fields="['id', 'consultingRoomId', 'customerId', 'doctorId', 'doctor', 'isFake']"
    :display-name-plural="$t('entities.MyReservations.Plural')"
    :display-name-singular="$t('entities.MyReservations.Singular')">
    <template #cell(reservationType)="row">
      {{ $t('Reservations.'+row.item.reservationType) }}
    </template>
  </DataTable>
</template>
<script>
import DataTable from '@components/admin/DataTable';

export default {
  components: {
    DataTable
  },
  data() {
    return {
      reservations: [],
      loading: true,
    };
  },
  created() {
    this.reload();
  },
  methods: {
    reload() {
      this.loading = true;
      this.axios.get('/admin/reservationsfordoctor').then((res) => {
        if (res.status === 200 && res.data.result.length > 0) {
          this.reservations = res.data.result;
          this.reservations.forEach((x) => {
            x.consultationEnd = this.$moment(x.consultationStart).add({ hours: (Number)(x.conslultationLength.split(':')[0]) }).format('DD.MM.YYYY HH:mm');
            x.consultationStart = this.$moment(x.consultationStart).format('DD.MM.YYYY HH:mm');
            delete x.conslultationLength;
          });

          this.reservations = this.reservations.map((x) => ({
            consultationStart: x.consultationStart,
            consultationEnd: x.consultationEnd,
            customer: x.customer,
            reservationType: x.reservationType
          }));
        } else {
          this.reservations = [];
        }
        this.loading = false;
      }).catch((err) => Promise.reject(err)).finally(() => {
        this.$refs.DataTable.finishSpinner();
      });
    }
  }
};
</script>
<style scoped></style>
